import { type RegistrationStatus } from '@exam-center/graphql';
import { Divider, Paper, SectionTitle } from '@shared/components';

import {
  ExamEventInformationReadonlyFields,
  type ExamEventInformationReadonlyFieldsProps,
} from '../exam-event-information-readonly-fields';
import { ExamEventStatusReadonlyField } from '../exam-event-status-readonly-field';

interface ExamEventReadonlyFieldsProps {
  slotProps: {
    status?: {
      status: RegistrationStatus;
      reason: string;
    };
  } & ExamEventInformationReadonlyFieldsProps['slotProps'];
}

export default function ExamEventReadonlyFields(props: Readonly<ExamEventReadonlyFieldsProps>) {
  const { slotProps } = props;
  return (
    <Paper
      sx={(theme) => ({
        flex: 1,
        p: theme.spacing(6),
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(6),
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <ExamEventInformationReadonlyFields slotProps={slotProps} />
      <Divider />
      <SectionTitle title='Exam Event Status' />
      <ExamEventStatusReadonlyField slotProps={slotProps} />
    </Paper>
  );
}
